import { LOCALES, SORTING_DIRECTION } from 'src/constants/main';

export interface ICountriesFilters {
  search: string;
  perPage: number | undefined;
  sortField: COUNTRIES_SORT_COLUMN;
  sortDir: SORTING_DIRECTION;
}

export enum COUNTRIES_SORT_COLUMN {
  NAME = 'name',
  NUMERIC_CODE = 'numeric_code',
  ALFA_2_CODE = 'alfa_2_code',
  ISD_CODE = 'isd_code',
  CREATED_AT = 'created_at',
}

export interface ICountryValidation {
  name: {
    [LOCALES.EN]: IDefaultCountryFieldValidation;
    [LOCALES.AR]: IDefaultCountryFieldValidation;
  };
  place_id: IDefaultCountryFieldValidation;
  numeric_code: IDefaultCountryFieldValidation;
  alfa_2_code: IDefaultCountryFieldValidation;
  isd_code: IDefaultCountryFieldValidation;
}

export interface IDefaultCountryFieldValidation {
  state: boolean;
  errorText?: string;
}

export interface ICountrySearchResult {
  name: string;
  placeId: string;
  locale: LOCALES;
}
